// tinymce.patch
// This patch enables the noneditable elements to have styling such as
// bold, underline, italic, font size/color applied and removed from them.
require('patch-loader?patch=..%2F..%2Fsrc%2Ftinymce.patch!tinymce/tinymce');

require('tinymce/themes/modern/theme');
require('tinymce/plugins/lists');
require('tinymce/plugins/paste');
require('tinymce/plugins/link');
require('tinymce/plugins/code');
require('tinymce/plugins/textcolor');
require('tinymce/plugins/noneditable');

// tinymce requires skin files to be present for async loading
var req = require.context(
   '!file-loader?name=[path][name].[ext]&context=node_modules/tinymce!tinymce/skins',
   true,
   /.*/
);

req.keys().forEach((file) => {
   // console.debug(`Loading tinymce skin file ${file}`);
   req(file);
});
